import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledSelectListItemDisease = styled(Flexbox)(
    ({theme: {palette, typography, spacing}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[950]};
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        cursor: pointer;
        &:hover {
            background-color: ${palette.neutral[100]};
        }
    `
)
